export default function getCurrentRouteName(path: string): string {
  // Since we are not using "react-resource-router" and route names are not available
  // Remove slashes from window.path
  if (path.length) {
    if (["/ja/", "/fr/", "/de/", "/es/", "/br/", "/zh/", "/ko/", "/ru/", "/pl/", "/it/", "/nl/", "/fi/", "/hu/", "/ro/", "/cs/"].includes(path)) {
      path.replace(
        /\/ja|\/fr|\/de|\/es|\/br|\/zh|\/ko|\/ru|\/pl|\/it|\/nl|\/fi|\/hu|\/ro|\/cs/,
        ''
      );
    }
    return path.replace(/^\//, "").replace(/\//g, "-").toLowerCase();
  }
  return "home";
}
